export default __webpack_public_path__ + "static/media/btn_bloquer_disable.310ffd16.svg";